import { use, useEffect } from "react";
import { z } from "zod/v4";
import { InternationalizationContext } from "./InternationalizationContext.tsx";
import { useTranslator } from "./translator.ts";

export const useLocalizedValidationMessages = () => {
  const { language } = use(InternationalizationContext);
  const translator = useTranslator();

  useEffect(() => {
    const customError: z.core.$ZodConfig["customError"] = (issue) => {
      if (issue.code === "too_small" && issue.origin === "string") {
        return translator("inputRequired");
      }
      if (issue.code !== "custom") {
        return undefined; // fallback to default message
      }
      // The cast allows any key, but the schemas in shared/types/apiTypes.ts only use texts without placeholders
      // eslint-disable-next-line local/valid-translation-values
      return translator(
        issue.params?.translationKey as Parameters<typeof translator>[0],
      );
    };

    if (language === "EN") {
      z.config({ ...z.locales.en(), customError });
    } else {
      z.config({ ...z.locales.de(), customError });
    }
  }, [language, translator]);
};
